<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
          <div class="page-title-box">
            <div class="float-right">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                <li class="breadcrumb-item active">Instansi</li>
              </ol>
            </div>
            <h4 class="page-title">Instansi</h4>
          </div>
        </div>
      </div>

    <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">Loading</p>
          </div>
      </div>

      <div class="card" v-else>
          <div class="card-body">
            <div class="wrapper-table-default">
                <router-link :to="{ name: 'adminInstanceCreate' }" class="btn btn-success waves-effect waves-light left-action">Tambah Instansi</router-link>
                <div class="table-responsive">
                    <table id="table-default" class="table table-hover with-action-last" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>Nama</th>
                                <th>Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in dataUser" :key="item.id">
                                <td>{{item.name}}</td>
                                <!-- <td>{{item.name}}</td> -->
                                <td>
                                    <div class="dropdown">
                                        <button class="btn btn-success dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <span>Lakukan Aksi <i style="font-size: 12px; margin-left: 10px;" class="fas fa-chevron-down"></i> </span>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <router-link class="dropdown-item" :to="{ name: 'adminInstanceEdit', params: { id: item.id } }">
                                                <i class="fas fa-pen"></i> Edit
                                            </router-link>

                                            <router-link class="dropdown-item" :to="{ name: 'adminFormEngine', params: { id: item.id } }">
                                                <i class="ti-panel"></i> Manajemen Form Engine
                                            </router-link>

                                            <router-link class="dropdown-item" :to="{ name: 'adminServices', params: { id: item.id } }">
                                                <i class="ti-server"></i> Manajemen Kategori Retribusi
                                            </router-link>

                                            <router-link class="dropdown-item" :to="{ name: 'adminMasterData', params: { id: item.id } }">
                                                <i class="ti-align-justify"></i> Manajemen Master Data
                                            </router-link>

                                            <button class="dropdown-item" @click.prevent="deleteItem(item.id)">
                                                <i class="fas fa-trash"></i> Hapus
                                            </button>

                                            <!-- <a class="dropdown-item" href="#!" 
                                            v-if="item.is_editable == true && item.status == 'WAITING_PROCESS' && $store.state.permission.includes('transaction.update')"
                                            @click.prevent="loadProcess(item.id)"><i class="fas fa-book"></i> Terbitkan Tagihan</a>

                                            <template v-if="item.is_editable">
                                                <a class="dropdown-item" href="#!" v-if="item.status != 'WAITING_PROCESS'" @click.prevent="loadDetail(item.id)"><i class="fas fa-eye"></i> Detail</a>
                                                <a class="dropdown-item" href="#!" v-if="item.status != 'WAITING_PROCESS'" @click.prevent="getPDF(item.id, item.invoice_code, 'SKRD')">
                                                    <i class="fas fa-print"></i> 
                                                    Cetak SKRD
                                                </a>
                                                <a class="dropdown-item" href="#!" v-if="item.status != 'WAITING_PROCESS' && item.penalty" @click.prevent="getPDF(item.id, item.invoice_code, 'STRD')">
                                                    <i class="fas fa-print"></i> 
                                                    Cetak STRD
                                                </a>
                                            </template>

                                            <template v-else>
                                                <a class="dropdown-item" href="#!" @click.prevent="loadDetail(item.id)"><i class="fas fa-eye"></i> Detail</a>
                                                <a class="dropdown-item" href="#!" @click.prevent="getPDF(item.id, item.invoice_code, 'SKRD')">
                                                    <i class="fas fa-print"></i> 
                                                    Cetak SKRD
                                                </a>
                                                <a class="dropdown-item" href="#!" v-if="item.penalty" @click.prevent="getPDF(item.id, item.invoice_code, 'STRD')">
                                                    <i class="fas fa-print"></i> 
                                                    Cetak STRD
                                                </a>
                                            </template>

                                            <a class="dropdown-item" href="#" @click.prevent="deleteItem(item.id, item.invoice_code)"><i class="fas fa-trash"></i> Hapus</a> -->
                                        </div>
                                    </div>
                                    <!-- <router-link class="btn btn-primary waves-effect waves-light"
                                        :to="{ name: 'adminInstanceEdit', params: { id: item.id } }"
                                        >
                                        <i class="fas fa-pen"></i>
                                    </router-link>
                                    <button class="btn btn-danger waves-effect waves-light ml-2" @click.prevent="deleteItem(item.id)">
                                        <i class="fas fa-trash"></i>
                                    </button> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
    data() {
        return {
            loading: true,
            dataUser: [],
        }
    },
    methods: {
        // LOAD SERVICE DATA
        loadData() {
            this.loading = true;
            this.$http.get(`${this.API_URL}company`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
            })
            .then(response => {
                this.loading = false;
                const result = response.data;
                
                if(result.success) {
                    this.dataUser = result.data
                    setTimeout(() => {
                        this.dataTableSearch()
                    }, 500);
                }else {
                    this.sAlert('error', result.message)
                }
            })
            .catch(error => {
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },

        // DELETE SERVICE DATA
        deleteItem(id){
            Swal.fire({
            title: 'Apakah anda yakin untuk menghapus pengguna ini ?',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, Hapus!'
            }).then((result) => {
                if (result.value) {
                     this.loading = true
                     this.$http.delete(`${this.API_URL}company/delete/${id}`, {
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
                    })
                    .then(() => {
                        this.loadData()
                    })
                    .catch(error => {
                        this.sAlert('error', "Error, Terjadi Kesalahan!")
                    });
                }
            })
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>